export async function callWithDefaultOnError<TResult>(f: () => Promise<TResult>, defaultValue: TResult): Promise<TResult> {
    try {
        return await f();
    } catch {
        return defaultValue;
    }
}
